import Vue from 'vue';
import App from './App.vue';
import { Lazyload } from 'vant';
import VueLazyload from 'vue-lazyload';
import router from './router/index';
import store from './store/index';
import animated from 'animate.css';
import { CDN_URL } from '@/config/index.js';
import VueLuckyCanvas from '@lucky-canvas/vue'
import setupDirective from '@/directive/setup'
// 移动端控制台打印
// import VConsole from 'vconsole';
// const vConsole = new VConsole();
import './styles/index.scss'; // 引入全局样式
import '@/views/forum/forum-common.css';
import './utils/rem.js';
import './utils/orientation.js';
import './utils/banwxfontsize';
// 图片懒加载时显示图片加载中...
Vue.use(VueLazyload);
Vue.use(VueLuckyCanvas)
setupDirective(Vue)
Vue.use(Lazyload, {
  loading: require('@/assets/timg.gif'),
  observer: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1,
  },
});
Vue.use(animated);
// productionTip设置为 false ，可以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.prototype.$cdnUrl = CDN_URL;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

console.log('灰度 1.0.3')

// 浏览器关闭前操作（上报数据）
const closeWindow = () => {
  // let vEvent = 'visibilitychange';
  // if (document.webkitHidden != undefined) {
  //   vEvent = 'webkitvisibilitychange';
  // } else if (document.msHidden != undefined) {
  //   vEvent = 'msvisibilitychange';
  // }
  // function visibilityChanged() {
  //   if (document.hidden || document.webkitHidden || document.msHidden) {
  //     document.title = '客官，别走啊~';
  //     reportData({ type: 13 });
  //   } else {
  //     console.log('Web page is visible.');
  //   }
  // }
  // document.addEventListener(vEvent, visibilityChanged, false);
  // document.addEventListener(
  //   'pagehide',
  //   function() {
  //     reportData({ type: 15 });
  //   },
  //   false,
  // );
  // document.addEventListener('visibilitychange', function() {
  //   if (document.visibilityState === 'visible') {
  //     console.log('显示');
  //   } else {
  //     reportData({ type: 13 });
  //   }
  // });
  // window.onbeforeunload = function() {
  //   reportExitTime();
  // };
  // if (getDevice().android) {
  //   //这个是安卓操作系统
  //   window.onbeforeunload = function() {
  //     reportExitTime();
  //   };
  // } else if (getDevice().ios) {
  //   console.log(2);
  //   //这个是ios操作系统
  //   window.addEventListener('pagehide', function() {
  //     reportExitTime();
  //   });
  // } else {
  //   console.log(3);
  //   //这个pc
  //   window.onbeforeunload = function() {
  //     reportExitTime();
  //   };
  // }
};

closeWindow();
